/**
 * @file 侧边导航store
 * @author sunyingying01
 */

import {makeObservable, action, observable} from 'mobx';

export class SiderNavigationStore {
    /** 侧边导航折叠标识 */
    collapsed: boolean = false;
    /** 侧边导航选中的菜单 */
    selectedMenu: MenuKeyType = 'projects';

    constructor() {
        makeObservable(this, {
            collapsed: observable,
            selectedMenu: observable,
            toggleCollapsed: action,
            setCollapsed: action,
            setSelectedMenu: action,
            enterTaskRunningPage: action,
            exitTaskRunningPage: action
        });
    }

    toggleCollapsed = () => {
        this.collapsed = !this.collapsed;
    };

    setCollapsed = (collapsed: boolean) => {
        this.collapsed = collapsed;
    };

    setSelectedMenu = (menuKey: MenuKeyType) => {
        this.selectedMenu = menuKey;
    };

    /** 进入任务运行页时，强制折叠 */
    enterTaskRunningPage = () => {
        this.collapsed = true;
    };

    /** 退出任务运行页时，恢复展开 */
    exitTaskRunningPage = () => {
        this.collapsed = false;
    };
}
